<template>
  <v-card
    variant="tonal"
    color="indigo"
    class="mx-auto"
    max-width="500"
    :text="info.formattedAddress"
    :title="info.displayName.text"
  >
    <v-card-actions>
      <v-btn>Select</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
    props: { 
        info: {
            type: Object,
            default: null
        } 
    },
    data() {
        return {
        };
    },
}

</script>

<style>
.get_information_button {
    margin-top: 20px;
}
</style>